export default "__VITE_ASSET__NBo6GC2E__"